<template lang="pug">
  v-container.pa-5
    div.h5.primary--text {{ $t('what_can_do.question') }}
    div.s1.primary--text.mt-4 {{ $t('what_can_do.text') }}
    div.p2.basic700--text.mt-1 {{ $t('what_can_do.text') }}

    div.mt-6(:style="form.type === 'pay_now' ? activeBorder : inactiveBorder" @click="$set(form, 'type', 'pay_now')")
      div.s1.primary--text {{ $t('answer_1.title') }}
      div.c1.primary--text {{ $t('answer_1.text') }}
    div.mt-3(:style="form.type === 'whatsapp' ? activeBorder : inactiveBorder" @click="$set(form, 'type', 'whatsapp')")
      div.s1.primary--text {{ $t('answer_2.title') }}
      div.c1.primary--text {{ $t('answer_2.text') }}
    div.mt-3(:style="form.type === 'both' ? activeBorder : inactiveBorder" @click="$set(form, 'type', 'both')")
      div.s1.primary--text {{ $t('answer_3.title') }}
      
</template>

<script>
export default {
  name: 'LandingFormType',
  props: ['parentForm'],
  data: () => ({
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)',
      padding: '16px'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '17px'
    }
  }),
  computed: {
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "what_can_do": {
      "question": "What can your customers do?",
      "text": "Select how you want your customers to proceed with their purchase"
    },
    "answer_1": {
      "title": "Directly pay for their purchase",
      "text": "Will appear as ‘Pay Now’ button"
    },
    "answer_2": {
      "title": "Chat with a sales member",
      "text": "Will appear as ‘WhatsApp’ button"
    },
    "answer_3": {
      "title": "Allow both options above"
    }
  },
  "id": {
    "what_can_do": {
      "question": "Apa yang bisa dilakukan pelanggan kamu?",
      "text": "Pilih bagaimana kamu ingin pelanggan melanjutkan pembelian"
    },
    "answer_1": {
      "title": "Membayar pembelian secara langsung",
      "text": "Tampilkan tombol 'Bayar Sekarang'"
    },
    "answer_2": {
      "title": "Chat dengan penjual",
      "text": "Tampilkan tombol 'WhatsApp'"
    },
    "answer_3": {
      "title": "Menyediakan kedua opsi diatas"
    }
  }
}
</i18n>